import React from "react";
import { compose } from "redux";
import { translate } from "react-i18next";
import { Form, Input } from "antd";
import PerfInput from "../perf-input";
import { SPAN_ONE_THIRD, SPAN_TWO_THIRDS } from "../../styles/constants";
import ZoomableTextarea from "../zoomable-textarea";
import _ from "lodash";

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS},
};

const onFieldsChange = (props, fields) => {
  props.onChange(_.mapValues(fields, ({value}) => value));
}
  
const NewSequenceMappingForm = ({ 
    t, 
    form
  }) => {
    return (
      <Form>
        <Form.Item 
          className="form-item-required"
          label={t("data.sequenceMapping.name.label")} 
          {...formItemLayout}
        >
          {form.getFieldDecorator("name", {getValueFromEvent: e => e.target.value.toUpperCase()})(
            <Input
              style={{textTransform: "uppercase"}}
            />
          )}
        </Form.Item>
        <Form.Item
          label={t("data.sequenceMapping.description.label")}
          {...formItemLayout}
        >
          {form.getFieldDecorator("description")(
            <PerfInput
              multilanguage={false}
              Component={ZoomableTextarea}
              />
          )}
        </Form.Item>      
      </Form>
  );
};

export default compose(
  translate(),
  Form.create({ onFieldsChange })
)(NewSequenceMappingForm);
